import { CardOrientation, ColorTokens, SizeTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import ThemeProvider from '@voltmoney/theme';
import { Pressable, View } from 'react-native';
import Gradient from '../gradient/Gradient';
import { applyMargin, applyPadding, } from '../stack/utils';
const Card = ({ header = { children: React.createElement(React.Fragment, null), widgetItems: [] }, body = { children: React.createElement(React.Fragment, null), widgetItems: [] }, footer = { children: React.createElement(React.Fragment, null), widgetItems: [] }, justifyContent, alignItems, bgColor, shadowColor, padding = {
    vertical: SizeTypeTokens.LG,
    horizontal: SizeTypeTokens.LG,
}, borderRadius = SizeTypeTokens.LG, shadow, borderColor, borderWidth, gradient, onPress, action, margin, 
// width,
height, triggerAction, renderItem, bodyOrientation = CardOrientation.VERTICAL, borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius, marginTop, needBorder, hide = false }) => {
    const theme = ThemeProvider.getTheme();
    const borderRadiusValue = theme.borderRadius[borderRadius];
    const borderTopLeftRadiusValue = theme.borderRadius[borderTopLeftRadius];
    const borderTopRightRadiusValue = theme.borderRadius[borderTopRightRadius];
    const borderBottomLeftRadiusValue = theme.borderRadius[borderBottomLeftRadius];
    const borderBottomRightRadiusValue = theme.borderRadius[borderBottomRightRadius];
    const backgroundColor = theme.colors[bgColor];
    const shadowColorX = theme.colors[shadowColor];
    const shadowValue = theme.shadow[shadow];
    const styleProps = React.useMemo(() => ({
        justifyContent,
        alignItems,
        backgroundColor: backgroundColor,
        elevation: shadowValue?.elevation || 0,
        shadowOffset: shadowValue?.shadowOffset || {
            height: 0,
            width: 0,
        },
        shadowColor: shadowColorX,
        borderTopLeftRadius: borderTopLeftRadiusValue,
        borderTopRightRadius: borderTopRightRadiusValue,
        borderBottomLeftRadius: borderBottomLeftRadiusValue,
        borderBottomRightRadius: borderBottomRightRadiusValue,
        shadowOpacity: shadowValue?.shadowOpacity || 0,
        shadowRadius: shadowValue?.shadowRadius || 0,
        borderRadius: borderRadiusValue,
        ...needBorder && {
            borderColor: theme.colors[borderColor] || theme.colors[ColorTokens.Grey_Night],
            borderWidth: borderWidth || 0,
        },
        marginTop: marginTop,
        ...applyPadding(padding),
        ...applyMargin(margin),
    }), [
        justifyContent,
        alignItems,
        shadowColor,
        shadow,
        bgColor,
        borderRadius,
        padding,
        margin,
        marginTop,
    ]);
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    const child = (React.createElement(React.Fragment, null, [
        header?.children,
        renderItem &&
            header?.widgetItems?.length > 0 &&
            header?.widgetItems.map(renderItem),
        body?.children,
        React.createElement(View, { style: {
                flexDirection: bodyOrientation ===
                    CardOrientation.HORIZONTAL
                    ? 'row'
                    : 'column',
            } }, renderItem &&
            body?.widgetItems?.length > 0 &&
            body?.widgetItems.map(renderItem)),
        footer?.children,
        renderItem &&
            footer?.widgetItems?.length > 0 &&
            footer?.widgetItems.map(renderItem),
    ]));
    const childWithBackground = gradient?.colors?.length > 1 ? (React.createElement(Gradient, { style: [styleProps], ...gradient }, child)) : (React.createElement(View, { style: [styleProps] }, child));
    return hide ? React.createElement(React.Fragment, null) : action ? (React.createElement(Pressable, { onPress: handleAction }, childWithBackground)) : (childWithBackground);
};
export default memo(Card);
export { Card };
